var map = {
	"./+10_.svg": "0bbb",
	"./-10_.svg": "1e11",
	"./AR Button.svg": "5b29",
	"./Burger Menu_grey.svg": "dd99",
	"./Burger Menu_white.svg": "aa76",
	"./Close Button.svg": "48ef",
	"./Drop Down Button.svg": "0c16",
	"./Isolation_Mode.png": "bb5a",
	"./Map button.svg": "60f9",
	"./Play button.png": "1d16",
	"./Tour button.svg": "be75",
	"./back_button.svg": "6b34",
	"./back_button_white.svg": "e91a",
	"./distance.svg": "88f4",
	"./excavation.svg": "40b2",
	"./map.png": "153a",
	"./map/Colonies Button Closed.png": "657f",
	"./map/Colonies Button Closed1.svg": "9c92",
	"./map/Colonies Button.svg": "6a41",
	"./map/Colony POI Icon.svg": "79a9",
	"./map/Excavation POI Icon_selected.svg": "f028",
	"./map/List Button_closed.png": "3b8f",
	"./map/List Button_open.svg": "3295",
	"./map/Location Button.svg": "c217",
	"./map/Map Button_open.svg": "87b2",
	"./map/North Button.svg": "9dcf",
	"./map/Tour Button Closed.svg": "e3f7",
	"./map/Tour Button.svg": "1726",
	"./map/Tour POI Icon.svg": "ebe7",
	"./map/excavation_poi.svg": "f591",
	"./map/map_closed.png": "fa02",
	"./map/poi-active.svg": "1715",
	"./map/poi.svg": "bd51",
	"./map/user-location.svg": "25bc",
	"./next.svg": "0043",
	"./pause.svg": "644b",
	"./play.svg": "dab1",
	"./poi-white.svg": "147d",
	"./poi.svg": "a5b0",
	"./previous.svg": "01ed",
	"./start-pois-tour.svg": "5a3b",
	"./start-tour.svg": "6505",
	"./time.svg": "79aa",
	"./tour-close.svg": "5bd3",
	"./tour-open.svg": "1062",
	"./tour.svg": "9e08"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";